import React from 'react'

/**
 * The "G" of the Georgia wordmark on its own, in `currentColor`. The sign-in page shows
 * it in the logo tile of the default (Georgia) brand and in the "Powered by" chip; the
 * full wordmark is not used there, the customer's name is.
 */
const GeorgiaMark: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 19.1 21.3" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" focusable="false" className={className}>
    <path d="M19.072 21.2297H10.6655C4.78452 21.2297 0 16.4679 0 10.6149C0 4.7619 4.78452 0 10.6655 0C13.256 0 15.7539 0.935884 17.699 2.635L15.3537 5.29422C14.0575 4.16185 12.3925 3.53835 10.6655 3.53835C6.74485 3.53835 3.55513 6.71289 3.55513 10.6149C3.55513 14.5169 6.74485 17.6914 10.6655 17.6914H15.5169V10.6149H19.072V21.2297Z" />
  </svg>
)

export default GeorgiaMark
